import React, { useState } from "react";
import { SearchIcon } from "@heroicons/react/solid";
import { connect, useSelector } from "react-redux";

import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";

// get step data from redux main state
const data = (state) => state.auth;

const CustomToolbar = (props) => {
  const [searchValue, setSearchValue] = useState("");
  let { defaultApiCall, customStep } = props;
  let { userType } = useSelector(data);

  // Search and date filter functions to send data in parent  start
  let _handleSearch = (e) => {
    let search = searchValue;
    props.handelSearchCandidate(search);
  };

  return (
    <div>
      <div className="flex flow-row items-center justify-between flex-wrap px-2">
        <div className="flex flex-row  w-9/12">
          <div className="w-[20%] py-4 mr-2">
            <button
              onClick={() => {
                customStep("InvitedUsers");
                defaultApiCall();
              }}
              id="dropdownDividerButton"
              data-dropdown-toggle="dropdownDivider"
              type="button"
              className="text-[white] w-full justify-center bg-[#007E8C] font-medium rounded-lg text-sm px-2 py-2.5 text-center flex flex-row items-center"
            >
              <ForwardToInboxIcon className=" mr-2" color="white" />
              Invited Users
            </button>
          </div>

          {/* <div className="w-[20%] py-4 mr-2">
            <button
              onClick={() => {
                customStep("SingleInvite");
                defaultApiCall();
              }}
              type="button"
              className="text-[white] w-full justify-center bg-[#007E8C] font-medium rounded-lg text-sm px-2 py-2.5 text-center flex flex-row items-center"
            >
              <PersonAddIcon className="mr-2" color="white" />
              Single Invite
            </button>
          </div> */}

          {/* {userType === "free" ? null : (
            <div className="w-[20%] py-4 mr-2">
              <button
                onClick={() => {
                  customStep("ListInvite");
                  defaultApiCall();
                }}
                type="button"
                className="text-[white] w-full justify-center bg-[#007E8C] font-medium rounded-lg text-sm px-2 py-2.5 text-center flex flex-row items-center"
              >
                <TocIcon className="mr-2 " color="white" />
                List Invite
              </button>
            </div>
          )}

          {userType === "free" ? null : (
            <div className="w-[20%] py-4 mr-2">
              <button
                onClick={() => {
                  customStep("BulkInvite");
                  defaultApiCall();
                }}
                type="button"
                className="text-[white] w-full justify-center bg-[#007E8C] font-medium rounded-lg text-sm px-2 py-2.5 text-center flex flex-row items-center"
              >
                <GroupAddIcon className=" mr-2" color="white" />
                Bulk Invite
              </button>
            </div>
          )} */}

          <div className="w-[20%] py-4 mr-2">
            <button
              onClick={() => {
                customStep("InviteTemplate");
                defaultApiCall();
              }}
              id="dropdownDividerButton"
              data-dropdown-toggle="dropdownDivider"
              type="button"
              className="text-[white] w-full justify-center bg-[#007E8C] font-medium rounded-lg text-sm px-2 py-2.5 text-center flex flex-row items-center"
            >
              <AttachEmailIcon className="mr-2" color="white" />
              Invite Template
            </button>
          </div>
        </div>

        <div className="w-3/12">
          <div className="flex justify-center items-center relative">
            <SearchIcon className="absolute text-[#8B83BA] left-2   w-6 h-6" />
            <input
              onChange={(e) => {
                setSearchValue(e.target.value);
                if (!e.target.value) {
                  props.handelSearchCandidate("");
                }
              }}
              value={searchValue}
              placeholder="Candidate Search"
              className="text-sm text-[#8B83BA] font-medium border border-[#E6E6E6] bg-[#F4F2FF] focus:outline-none pl-10 pr-10 focus:bg-white focus:border-gray-500 rounded-lg py-2.5 w-full"
            />
            {searchValue.length > 0 ? (
              <button
                onClick={_handleSearch}
                className="absolute right-2 text-[#FFFFFF] bg-[#A79FD7] text-xs border broder-[#A79FD7] px-2 rounded-lg py-2 "
              >
                Search
              </button>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {})(CustomToolbar);
